<template>
  <div class="app-container">
    <div class="wt-form-inputs-container">
      <div class="wt-form-inputs-content">
        <el-form size="small" :inline="true" class="wt-form-inputs">
          <el-form-item label="时间：">
            <el-date-picker v-model="form.dataTimeRange"
              type="datetimerange" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" :unlink-panels="true">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="统计机构">
            <el-select v-model="form.type" placeholder="请选择" @change="handleTypeChange">
              <el-option label="全部" :value="1"></el-option>
              <el-option label="物业总公司" :value="2"></el-option>
              <el-option label="站点" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="总公司" v-if="form.type === 2">
            <el-select v-model="form.orgId1" placeholder="请选择">
              <el-option v-for="item in siteOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="站点：" v-if="form.type === 3">
            <el-cascader
              class="search-ascader"
              v-model="form.siteIdList"
                :options="siteOptions"
                :props="props"
                 placeholder="请选择"
                 filterable
                 collapse-tags
                clearable></el-cascader>
          </el-form-item>
          <el-button size="small" type="primary" @click="toClickAction('search')">查询</el-button>
          <el-button size="small"  @click="toClickAction('reset')">重置</el-button>
          <el-button size="small"  @click="exportChart('积分池统计')">导出</el-button>
        </el-form>
      </div>
    </div>
    <div class="chart-tile-section">
      <div class="chart-tile-item">
        <div class="label">
          <div>积分累计发放总量：</div>
          <div>（系统以各种形式发放的总积分）</div>
        </div>
        <div class="value">{{detail.sumIssueIntegral}}</div>
      </div>
      <template v-if="form.type === 2">
        <div class="chart-tile-item">
          <div class="label">
            <div>积分总消耗量：</div>
            <div>(用户以各种形式消耗的积分总数）</div>
          </div>
          <div class="value">{{detail.sumConsumptionIntegral}}</div>
        </div>
        <div class="chart-tile-item">
          <div class="label">物业公司积分余量池：</div>
          <div class="value">{{detail.sumPropertyChargeReIntegral}}</div>
        </div>
      </template>
      <div class="chart-tile-item" v-if="form.type === 1">
        <div class="label">
          <div>积分总消耗量（含物业费)：</div>
          <div>(用户以各种形式消耗的积分总数）</div>
        </div>
        <div class="value">{{detail.sumConsumptionIntegral}}</div>
      </div>
      <div class="chart-tile-item" v-if="form.type === 3">
        <div class="label">
          <div>商品兑换消耗量：</div>
          <div>(用户以各种形式消耗的积分总数）</div>
        </div>
        <div class="value">{{detail.sumOrderIntegral}}</div>
      </div>
      <div class="chart-tile-item" v-if="form.type !== 2">
        <div class="label">积分余量池：</div>
        <div class="value">{{detail.sumRemainingIntegral}}</div>
      </div>
    </div>
    <div class="chart-tile-section">
      <div class="chart-tile-item">
        <div class="label">可回收物投递积分总量：</div>
        <div class="value">{{detail.sumDeliveryGarbageIntegral}}</div>
      </div>
      <div class="chart-tile-item" v-if="form.type !== 3">
        <div class="label">积分抵物业费消耗量：</div>
        <div class="value">{{detail.sumPropertyChargeIntegral}}</div>
      </div>
      <div class="chart-tile-item" v-if="form.type === 1">
        <div class="label">物业公司积分余量池：</div>
        <div class="value">{{detail.sumPropertyChargeReIntegral}}</div>
      </div>
    </div>
    <div class="chart-tile-section">
      <div class="chart-tile-item">
        <div class="label">其他积分累计发放：</div>
        <div class="value">{{detail.sumOtherIntegral}}</div>
      </div>
      <div class="chart-tile-item" v-if="form.type !== 3">
        <div class="label">商品兑换消耗量：</div>
        <div class="value">{{detail.sumOrderIntegral}}</div>
      </div>
    </div>
    <div class="chart-tile-section" v-if="form.type === 1">
      <div class="chart-tile-item">
        <div class="label">平台累计发放：</div>
        <div class="value">{{detail.sumPlatformIntegral}}</div>
      </div>
      <div class="chart-tile-item">
        <div class="label">平台消耗量：</div>
        <div class="value">{{detail.sumPlatformConIntegral}}</div>
      </div>
      <div class="chart-tile-item">
        <div class="label">平台积分余量池：</div>
        <div class="value">{{detail.sumPlatformReIntegral}}</div>
      </div>
    </div>
    <div class="chart-tile-section" v-if="form.type === 1">
      <div style="width: calc(33.33333% - 14px);"></div>
      <div class="chart-tile-item">
        <div class="label">售货柜积分消耗量：</div>
        <div class="value">{{detail.sumContainerForSaleIntegral}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from './mixin.js'
export default {
  name: 'StatisticalAnalysisPoints',
  mixins: [mixin],
  data() {
    return {
      loading: false,
      form: {
        dataTimeRange: [],
        siteIdList: [],
        type: 1,
        orgId1: ''
      },
      props: { children: 'childList', label: 'name', value: 'id', emitPath: false, expandTrigger: 'hover', multiple: true },
      siteOptions: [],
      detail: {}
    }
  },
  created() {
    this.initCreated()
  },
  mounted() {
    const that = this
    window.addEventListener('resize', that.resizeView)
    this.initPage()
  },
  beforeDestroy() {
    const that = this
    window.removeEventListener('resize', that.resizeView)
  },
  methods: {
    initCreated() {
      this.orgTreeList()
    },
    // 初始化页面
    initPage() {
      this.siteStatistical()
    },
    toClickAction(type) {
      if (type === 'reset') {
        this.form = {
          dataTimeRange: [],
          orgId1: '',
          siteIdList: [],
          type: 1
        }
      }
      this.initPage()
    },
    handleTypeChange() {
      this.form.orgId1 = ''
      this.form.siteIdList = []
      this.siteStatistical()
    },
    exportChart(name) {
      const that = this
      const timer = (new Date()).getTime()
      const fileName = (name || '工单') + timer + '.xlsx'
      const params = JSON.parse(JSON.stringify(this.form))
      params.orgId1 = this.$wtUtil.getRealOrgId(params.orgId1)
      this.$wtUtil.downloadFile({
        url: window.wtConst.BASE_API + '/modules/statisticalIntegralPool/integralPoolStatisticalImport',
        data: params,
        fileName: fileName
      }).then((res) => {
        console.log('导出成功')
      }).catch((err) => {
        that.$message({ message: err, type: 'error' })
      })
    },
    // 积分统计
    siteStatistical() {
      this.loading = true
      const params = JSON.parse(JSON.stringify(this.form))
      params.orgId1 = this.$wtUtil.getRealOrgId(params.orgId1)
      this.$api.statistical.pool.integralPoolStatistical(params).then(res => {
        this.loading = false
        this.detail = res.data
      }).catch(() => {
        this.loading = false
      })
    },
    // 站点
    orgTreeList() {
      this.$api.siteManage.org.orgTreeList().then(res => {
        this.$wtUtil.setSiteLevelKey(res.data)
        this.siteOptions = res.data
      })
    }
  }
}
</script>
